<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"><i></i> </p>
<p class="p5"><i>For Bertha Merriman</i></p>
<p class="p5"><i>A pioneer who lived in a tougher time...</i></p>
<p class="p5"><i>With love from a grandchild</i></p>
<p class="p3"> </p>
<p class="p4"><b></b> </p>
<p class="p4"><b></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?479289de